module.exports = __webpack_public_path__ + "static/media/jeremy-yap.5b68286c.jpg";